/* eslint-disable */
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../components/Table/PageTable';
import {
  EnumMerchantPaidMethod,
  EnumMerchantPaidStatus,
  EnumOrderGroupStatus, EnumOrderManagementSortField,
  EnumOrderMerchantStatus, EnumOrderStatus,
  EnumOrderStatusBy,
  EnumPagingMode,
  EnumShippingMethod,
  findEnumById,
} from '../../../../constants/enum';
import { COMMON_CONST } from '../../../../constants/constants';
import { isEmpty, isEmptyObject } from '../../../../utils/utils';
import { trans } from '../../../../localization/index';
import CustomerPaymentBy from '../OrderDetail/components/CustomerPaymentBy';
import MAssignedCountDownTime from './MAssignedCountDownTime';
import { getSortData } from '../../../../utils/sort';
import { handleChangeFilters } from '../actions';

import TableEmpty from '../../../../components/Common/TableEmpty'


import TimeIcon from '../../../../assets/common/images/icon/time.png'


const svgMap = {
  'order-confirm':TimeIcon
}

function isAllowCancelOrder(allowCancel, orderStatus, payToMerchant) {
  const { state: payState, type: payType } = payToMerchant;

  return (
    allowCancel &&
    [
      EnumOrderStatus.CONFIRMED.id,
      EnumOrderStatus.AUTO_ASSIGN.id,
      EnumOrderStatus.AUTO_ASSIGN_TIMEOUT.id,
      EnumOrderStatus.ASSIGNED.id,
      EnumOrderStatus.REASSIGNED.id,
      EnumOrderStatus.INCHARGED.id,
      EnumOrderStatus.DENIED.id,
    ].includes(orderStatus) &&
    payType === EnumMerchantPaidMethod.TOPPAY.id &&
    payState === EnumMerchantPaidStatus.PAID
  );
}

function PageTableCellStatus({
  status,
  statusBy,
  assignee,
  orderCodeFilter,
  statusFilter,
  shipping,
  confirmExpiredTime,
  payToMerchant,
  allowCancel,
  orderStatus,
  isASAP,
}) {
  const statusEnum = findEnumById(EnumOrderMerchantStatus, status);
  const { class: className, icon, description } = statusEnum || {};

  return (
    <PageTableCell textAlign="center">
      <div className="order-detail-status-cell">
      {statusFilter.value === EnumOrderGroupStatus.SCHEDULED.id && !isASAP &&
        <span className="btn btn-block order-scheduled">
          {trans('scheduled_order')}
        </span>
      }
      {statusFilter.value === EnumOrderGroupStatus.PROCESSING.id && !isASAP &&
        <span className="btn btn-block btn-green">
          {trans('scheduled')}
        </span>
      }

      {[
        EnumOrderMerchantStatus.M_ASSIGNED.id,
        EnumOrderMerchantStatus.M_RECEIVED.id,
      ].includes(status) && confirmExpiredTime ? (
        <MAssignedCountDownTime deliveryTime={confirmExpiredTime} />
      ) : (
        <span className={`btn btn-block ${className || ''}`}>
          {/* <i className={icon || ''} /> */}
          {svgMap[className] && <img src={svgMap[className]} style={{width:'16px',verticalAlign:'middle',margin:'0 4px 0 0'}}/>}
          {
            isAllowCancelOrder(allowCancel, orderStatus, payToMerchant)
              ? trans('allow_cancel_restaurant')
              : trans(description || '')
          }
        </span>
      )}
      {statusFilter.value === EnumOrderGroupStatus.CONFIRMED.id && (
        <span className="confirm-via">
            {`${trans('mod_confirm_by')} ${trans(
              findEnumById(EnumOrderStatusBy, statusBy).description,
            )}`}
        </span>
      )}
      {!isEmptyObject(assignee) &&
        status !== EnumOrderMerchantStatus.CANCELLED.id && (
          <span className="confirm-via">
            {`${trans('mod_delivery_by')} ${assignee.name}`}
          </span>
        )}
      {!isEmptyObject(shipping) &&
        shipping.type === EnumShippingMethod.PICKUP.id && (
          <span className="btn btn-dark btn-block mt-1">
            {trans(findEnumById(EnumShippingMethod, shipping.type).description)}
          </span>
        )}
      </div>
    </PageTableCell>
  );
}

function PageTableCellPrice({
  isPaidToMerchant,
  totalValue,
  payToMerchant,
  totalCount,
  distance,
  vat,
}) {
  return (
    <PageTableCell className="col-total" textAlign="right">
      <div className="font-weight-bold">
        {isPaidToMerchant && (
          <i className="fas fa-check-circle text-red mr-1" />
        )}

        <span className="text-red">{totalValue}</span>
      </div>
      {isPaidToMerchant && (
        <div>
          {`${trans('mod_paid')} `}
          {trans(
            findEnumById(EnumMerchantPaidMethod, payToMerchant.state)
              .description,
          )}
        </div>
      )}
      <div className="total-qty">
        <div>
          <span>{totalCount}</span> {trans('mod_dish')}
        </div>
        &nbsp;- <div className="distance">{distance}</div>
      </div>

      {vat > 0 && (
        <span className="text-black">{trans('mod_vat_invoice')}</span>
      )}
    </PageTableCell>
  );
}

class OrderManagementTable extends Component {
  renderHeader = () => {
    const { filters } = this.props;
    const { sortInfo } = filters;
    const { sort, sortOrder } = sortInfo;

    const columns = [
      {
        id: 'number',
        label: trans('mod_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'code',
        label: trans('mod_header_code'),
        width: '35%',
        textAlign: 'left',
        sort: EnumOrderManagementSortField.ORDER_CODE.id,
      },
      {
        id: 'order_time',
        label: trans('mod_header_delivery_time'),
        width: '185px',
        textAlign: 'center',
        className: 'header-px',
        sort: EnumOrderManagementSortField.DELIVERY_TIME.id,
      },
      {
        id: 'count_down_time',
        label: trans(''),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'total_qty',
        label: trans('mod_header_total'),
        width: '15%',
        textAlign: 'right',
        sort: EnumOrderManagementSortField.TOTAL.id,
      },
      {
        id: 'status',
        label: trans('mod_header_status'),
        width: '13%',
        textAlign: 'center',
        sort: EnumOrderManagementSortField.STATUS.id,
      },
      {
        id: 'detail',
        label: trans('mod_header_detail'),
        width: '7%',
        textAlign: 'center',
      },
    ];

    return (
      <PageTableHeader
        columns={columns}
        onClick={this.onSort}
        sort={sort}
        sortOrder={sortOrder}
      />
    );
  };

  onSort = (newSort) => {
    const { filters, handleSearchOrder, handleChangeFiltersConnect } = this.props;
    const { sortInfo } = filters;
    const { sort: oldSort, sortOrder: oldSortOrder } = sortInfo;

    handleChangeFiltersConnect('sortInfo', getSortData(oldSort, newSort, oldSortOrder));
    handleSearchOrder();
  };

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={20} noPadding>
          <TableEmpty txt="np_order_not_found"/>
        </PageTableCell>
      </PageTableRow>
    );
  }

  renderRow = (row, index) => {
    const { getOrderDetail, filters } = this.props;
    const { orderCode: orderCodeFilter, status: statusFilter } = filters;
    const currentDate = moment(new Date(), COMMON_CONST.FormatDate);
    const {
      deliver_address: deliverAddress,
      total_value: totalValue,
      items,
      status,
      assignee,
      status_by: statusBy,
      code,
      distance,
      order_time: orderTime,
      deliver_time: deliverTime,
      shipping,
      pay_to_merchant: payToMerchant,
      customer_pay: customerPay = {},
      vat,
      confirm_expired_time: confirmExpiredTime,
      allow_cancel: allowCancel,
      order_status: orderStatus,
      is_asap: isASAP,
    } = row;
    const orderTimeOrder = moment(orderTime, COMMON_CONST.FormatDateTime);
    const deliverTimeOrder = moment(deliverTime, COMMON_CONST.FormatDateTime);
    const duration = moment.duration(deliverTimeOrder.diff(currentDate));
    const durationMinutes = Math.floor(duration.asMinutes());
    let durationMinutesText = `${durationMinutes}'`;
    if (durationMinutes >= 1000) {
      durationMinutesText = "999'+";
    } else if (durationMinutes <= -1000) {
      durationMinutesText = "-999'-";
    }
    const isPaidToMerchant =
      payToMerchant.state === EnumMerchantPaidStatus.PAID;
    return (
      <PageTableRow key={code}>
        <PageTableCell textAlign="center">{index}</PageTableCell>
        <PageTableCell textAlign="left">
          <strong>{code}</strong>
          <div className="pt-2 pb-1">
            <span className="text-black font-weight-bold">
              {deliverAddress.name}
            </span>{' '}
            <CustomerPaymentBy customerPay={customerPay} />
          </div>
          {deliverAddress.address ? <div className="font12">{deliverAddress.address}</div> : null}
        </PageTableCell>
        <PageTableCell className="col-order-time" textAlign="center">
          <div>Ord：{orderTimeOrder.format(COMMON_CONST.FormatDateView)}</div>
          <div>
            Deli：<span className="text-success">
            {deliverTimeOrder.format(COMMON_CONST.FormatDateView)}
            </span>
          </div>
        </PageTableCell>
        <PageTableCell className="col-countdown" textAlign="center">
          {[
            EnumOrderGroupStatus.PROCESSING.id,
            EnumOrderGroupStatus.CONFIRMED.id,
          ].includes(statusFilter.value) && (
            <span
              className={`count-down-time ${
                durationMinutes < 0 ? 'alert-time' : ''
              }`}
            >
              {durationMinutesText}
            </span>
          )}
        </PageTableCell>
        <PageTableCellPrice
          isPaidToMerchant={isPaidToMerchant}
          totalValue={totalValue}
          payToMerchant={payToMerchant}
          totalCount={items.total_count}
          distance={distance}
          vat={vat}
        />
        <PageTableCellStatus
          status={status}
          statusBy={statusBy}
          assignee={assignee}
          orderCodeFilter={orderCodeFilter}
          statusFilter={statusFilter}
          shipping={shipping}
          confirmExpiredTime={confirmExpiredTime}
          allowCancel={allowCancel}
          payToMerchant={payToMerchant}
          orderStatus={orderStatus}
          isASAP={isASAP}
        />
        <PageTableCell className="col-detail" textAlign="center">
          <button
            type="button"
            className="btn btn-white"
            onClick={() => getOrderDetail(code)}
          >
            {trans('mod_detail')}
          </button>
          <a
            hidden
            href={`foodyposprint://order?link=https://www.shopeefood.vn/bill/${code}`}
            className="btn btn-block btn-gray"
          >
            <i className="fas fa-print mr-1" />
            {trans('mod_print_bill')}
          </a>
        </PageTableCell>
      </PageTableRow>
    );
  };

  render() {
    const { table, changeActivePage, changePageSize, getList } = this.props;

    return (
      <PageTable
        className="order-table"
        paginationMode={EnumPagingMode.PAGING_IDS.id}
        table={table}
        renderHeader={this.renderHeader}
        renderRow={this.renderRow}
        renderEmpty={OrderManagementTable.renderEmpty}
        changeActivePage={changeActivePage}
        changePageSize={changePageSize}
        getList={getList}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  filters: state.order.filters,
});

const mapDispatchToProps = ({
  handleChangeFiltersConnect: handleChangeFilters
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderManagementTable);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/components/OrderManagementTable.jsx